import * as api from '../api';

const state = {
    isFetching: false,
    error: null,

    id: null,
    subscription: null,
    trucks: [],
    trailers: [],
    clients: [],
    projects: [],
    materials: [],
    drivers: [],
    ticketCounter: null,
    timeRoundingEnabled: false,
    timeRoundingInterval: null,
    timeZone: null,
};

const getters = {
    subscriptionSuspended(state) {
        return state.subscription && new Date(state.subscription.graceEndsAt) < new Date();
    },

    activeDrivers(state) {
        return state.drivers.filter(driver => driver.isActive);
    },

    timeZone(state) {
        return state.timeZone;
    },

    // HACK: Check if the company is Clark LLC to handle formatting differently
    // on reports to change Tons to Cubic Yards. This should be handled in the
    // backend, but this is a quick fix for now until we learn more about the
    // product need for this feature.
    isClarkLlc(state) {
        return state.id === 115;
    },
};

const mutations = {
    FETCH_PENDING(state) {
        state.isFetching = true;
    },

    FETCH_SUCCESS(state, overview) {
        state.id = overview.id;
        state.subscription = overview.subscription;
        state.trucks = overview.vehicles.filter(vehicle => vehicle.type === 'truck');
        state.trailers = overview.vehicles.filter(vehicle => vehicle.type === 'trailer');
        state.clients = overview.clients;
        state.projects = overview.projects;
        state.materials = overview.materials;
        state.drivers = overview.drivers;
        state.ticketCounter = overview.ticketCounter;
        state.timeRoundingEnabled = !!overview.timeRoundingInterval;
        state.timeRoundingInterval = overview.timeRoundingInterval;
        state.timeZone = overview.timeZone;

        state.isFetching = false;
        state.error = null;
    },

    FETCH_FAILURE(state, error) {
        state.isFetching = true;
        state.error = error.message;
    },
};

const actions = {
    async fetchOverview({ rootGetters, commit }) {
        const companyId = rootGetters['auth/company'].id;

        commit('FETCH_PENDING');
        const res = await api.getCompanyOverview(companyId);
        if (res.error) {
            return commit('FETCH_FAILURE', res.error);
        }

        commit('FETCH_SUCCESS', res.body);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
